import React, { Component } from 'react';
import classNames from 'classnames';

import { BillDownload, BillView, DetailDownload } from '../../images';



class Item extends Component {
  constructor() {
    super();
    this.handleHover = this.handleHover.bind(this);
    this.state = { isHovered: false };
  }

  handleHover(){
    this.setState({
        isHovered: !this.state.isHovered
    });
  }
  render() {
    let billsClass = classNames({
      'row': true,
      'row-body': true,
      'colors': this.state.isHovered
    });
    let {invoice} = this.props
    return (
      <div className={billsClass} onMouseEnter={this.handleHover} onMouseLeave={this.handleHover} style={{ height: 65}} key={invoice.id}>
        <div className="col-1 hidden-md-down">
          <label className="custom-control custom-checkbox">
            <input className="custom-control-input" type="checkbox" /><span className="custom-control-indicator"></span>
          </label>
        </div>
        <div className="col-6 col-md-3 col-lg-2"><small className="hidden-md-up">date: </small><span className="ng-binding">{invoice.invoice_date}</span></div>
        <div className="col-6 col-md-3 push-md-4 col-lg-2 push-lg-4 text-right"><small className="hidden-md-up">montant: </small><span className="ng-binding">{invoice.total_paid_real}</span></div>
        <div className="col-8 col-md-4 pull-md-3 col-lg-4 pull-lg-2 ng-binding">{invoice.invoice_number}</div>
        <div className="col-4 col-md-2 col-lg-3 text-right">
          <a className="btn-action bill-view" href={`${process.env.REACT_APP_BASEURL_INVOICE}${invoice.previewInvoice}`}><img src={BillView} alt="Profile" /></a>
          <a className="btn-action bill-download hidden-md-down" href={`${process.env.REACT_APP_BASEURL_INVOICE}${invoice.downloadInvoice}`}><img src={BillDownload} alt="bill-download" /></a>
          <a className="btn-action bill-download hidden-md-down" href={`${process.env.REACT_APP_BASEURL_INVOICE}${invoice.downloadCallDetails}`}><img src={DetailDownload} alt="bill-download" /></a>
        </div>
      </div>
    )
  }
}
export default Item;



// WEBPACK FOOTER //
// ./src/lib/tables/Item.js